<template>
  <div class="option-list">
    <div
      v-for="(opcion, i) in opcionales"
      :key="`opcional_${i}`"
      class="option-row"
      :class="{ 'option-row--active': isSelected(opcion) }"
      @click="select(opcion)"
    >
      <div class="option-label">{{ opcion.nombre }}</div>
      <v-icon :color="isSelected(opcion) ? 'primary' : undefined">
        {{ isSelected(opcion) ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
      </v-icon>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Opcionales',
  props: {
    opcionales: {
      type: Array
    },
    llevaImporte: {
      type: Boolean
    }
  },
  mounted () {
    if (this.opcionales && this.opcionales.length) {
      this.select(this.opcionales[0], true)
    }
  },
  data () {
    return {
      selection: null
    }
  },
  methods: {
    isSelected (opcion) {
      return this.selection && this.selection.id === opcion.id
    },
    select (opcion, initial) {
      if (!opcion) return
      if (this.selection && this.selection.id === opcion.id && !initial) return
      const oldValue = this.selection
      if (oldValue) this.$emit('removeItem', oldValue)
      const next = { ...opcion, cant: 1 }
      this.selection = next
      this.$emit('addItem', next)
      if (this.llevaImporte) {
        if (oldValue) this.$emit('restarImporte', oldValue.PrecioUnitario)
        this.$emit('sumarImporte', next.PrecioUnitario)
      }
    }
  }
}
</script>
<style scoped>
.option-list {
  margin: 0 -4px;
}
.option-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  cursor: pointer;
}
.option-row:last-child {
  border-bottom: none;
}
.option-label {
  font-size: 0.95rem;
  font-weight: 500;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.87);
  flex: 1;
  min-width: 0;
}
.option-row--active .option-label {
  font-weight: 600;
}
</style>
